<template>
    <Paper class="guideManageMain">
        <div class="guideManage">
            <el-row>
                <el-col :span="19">
                    <el-row>
                        <el-col class="guideManage-list">
                            <el-input v-model="searchData.guideName" placeholder="操作指南名称"></el-input>
                        </el-col>
                        <el-col class="guideManage-list">
                            <el-select clearable v-model="searchData.status" placeholder="状态">
                                <el-option v-for="item in enableDisable" :key="item.value" :label="item.label" :value="item.value"></el-option>
                            </el-select>
                        </el-col>
                        <el-col class="guideManage-list">
                            <el-date-picker
                                v-model="timeHorizon"
                                class="guideManage-search-date"
                                type="daterange"
                                align="left"
                                value-format='yyyy-MM-dd HH:mm:ss'
                                :default-time="['00:00:00', '23:59:59']"
                                unlink-panels
                                range-separator="-"
                                :start-placeholder="$translate('lang.E3202101270023', { defaultText: '开始日期' })"
                                :end-placeholder="$translate('lang.E3202101270024', { defaultText: '结束日期' })"
                                size="mini"
                                :picker-options="pickerOptions">
                            </el-date-picker>
                        </el-col>
                        <div>
                            <el-button @click="searchChange" type="primary" size="mini" icon='el-icon-search'>
                                {{$translate('lang.E3202101260004', { defaultText: '查 询' })}}
                            </el-button>
                            <el-button class="sn-search-reset-button" @click="reset" size="mini">
                                {{$translate('lang.E3202101260009', { defaultText: '重 置' })}}
                            </el-button>
                        </div>
                    </el-row>
                </el-col>
            </el-row>
        </div>
        <m-table
            ref="mPlane"
            :pageTotal="pageTotal"
            :tableData="tableData"
            @btn-event="btnEvent"
            @pageChange="pageChange"
            @sizeChange="sizeChange"
            @switch-change="switchChange"
            :config="config">
            <div slot="page-module-btn">
            <el-button @click="addData" icon="el-icon-plus" type="primary" size="mini">
                {{$translate('lang.E3202102260005', { defaultText: '新增' })}}
            </el-button>
            </div>
        </m-table>
        <add-guide :dialogVisible.sync="dialogVisible" :ruleForm="ruleForm" :saveLoading="saveLoading" @saveData="saveData"></add-guide>
    </Paper>
</template>
<script>
import Paper from '@/components/core/paper/Paper';
import mTable from '../../../components/IdentityComponent/Main';
import addGuide from './addGuide';
import config from './config';
import { enableDisable, pickerOptions } from '../../../utils/generalOption';
import { guideSearch, guideDelete, guideAdd, editAdd, editStatus } from '../../../api/guideManage';
export default {
    name: 'guideManage',
    components: { Paper, mTable, addGuide },
    data() {
        return {
            config: config,
            searchData: {
                guideName: '',
                status: ''
            },
            ruleForm: {},
            timeHorizon: [],
            pageNo: 1,
            pageSize: 10,
            pageTotal: 0,
            tableData: [],
            enableDisable: enableDisable,
            pickerOptions: pickerOptions,
            dialogVisible: false,
            saveLoading: false
        };
    },
    methods: {
        searchChange() {
            this.$refs.mPlane.$refs.page.pageState = false;
            this.pageNo = 1;
            this.config.page.pageSize = 1;
            this.searchloading = true;
            this.loadData();
            this.$nextTick(() => {
                this.$refs.mPlane.$refs.page.pageState = true;
            });
        },
        reset() {
            this.searchData = this.$options.data.call(this).searchData;
            this.timeHorizon = [];
        },
        addData() {
            this.ruleForm = { status: 'Y' };
            this.dialogVisible = true;
        },
        switchChange(data) {
            const params = {
                id: data.id,
                status: data.status
            };
            editStatus(params).then(res => {
                if (res && +res.code === 0) {
                    this.loadData();
                }
            });
        },
        saveData(data) {
            const params = data || {};
            if (params.id) {
                this.updateInfo(params);
            } else {
                this.savegisInfo(params);
            }
        },
        updateInfo(params) {
            this.saveLoading = true;
            editAdd(params).then(res => {
                if (res && +res.code === 0) {
                    this.$message.success('更新成功！');
                    this.loadData();
                    this.dialogVisible = false;
                }
            }).finally(() => {
                this.saveLoading = false;
            });
        },
        savegisInfo(params) {
            this.saveLoading = true;
            guideAdd(params).then(res => {
                if (res && +res.code === 0) {
                    this.$message.success('新增成功！');
                    this.loadData();
                    this.dialogVisible = false;
                }
            }).finally(() => {
                this.saveLoading = false;
            });
        },
        btnEvent(rowData, event) {
            switch (event) {
            case 'edit':
                this.editBtn(rowData);
                break;
            case 'delete':
                this.deleteBtn(rowData);
                break;
            default:
                break;
            }
        },
        editBtn(row) {
            this.ruleForm = row;
            this.dialogVisible = true;
        },
        deleteBtn(row) {
            if (!row || !row.id) { return; }
            this.$confirm('是否删除该条指南?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                guideDelete(row.id).then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success(`删除成功`);
                        this.loadData();
                    }
                });
            });
        },
        pageChange(data) {
            this.pageNo = data;
            this.loadData();
        },
        sizeChange(data) {
            this.pageSize = data;
            this.loadData();
        },
        loadData() {
            const params = {
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                ...this.searchData
            };
            if (this.timeHorizon.length) {
                params.startTime = this.timeHorizon[0];
                params.endTime = this.timeHorizon[1];
            }
            guideSearch(params).then(res => {
                if (res && +res.code === 0) {
                    this.tableData = res.data.list;
                    this.pageTotal = res.data.totalCount;
                }
            });
        }
    },
    mounted() {
        this.loadData();
    }
};
</script>
<style lang="less">
.guideManageMain {
    .nPanel .el-table {
        height: calc(100vh - 180px) !important;
    }
    .nPanel .row-bg {
        margin-top: 20px;
    }
}
.guideManage{
    margin-bottom: 20px;
    .guideManage-list{
        width: 190px;
        margin-right: 10px;
        .el-select{
            width: 100%;
        }
    }
    .guideManage-search-date{
        width: 100%;
        .el-range__icon {
            display: none;
        }
    }
}
</style>